import { Routes, Route, Navigate } from 'react-router-dom';
import { ProtectedRoute } from './ProtectedRoute';

// Public Pages
import { Login } from '@/features/auth/pages/Login/index';
import { Signup } from '@/features/auth/pages/Signup/index';
import ForgotPassword from '@/features/auth/pages/ForgotPassword/ForgotPassword';
import ResetPassword from '@/features/auth/pages/ResetPassword/ResetPassword';

// Admin Layout & Pages
import { AdminLayout } from '@/features/admin/components/layout/AdminLayout';
import { Dashboard } from '@/features/admin/pages/Dashboard/Dashboard';
import { SuperOrganizations } from '@/features/admin/pages/SuperOrganizations';
import { SuperOrgMembers } from '@/features/admin/pages/SuperOrgMembers';
import { SharkSettings } from '@/features/admin/pages/SharkSettings/SharkSettings';
import { Integrations } from '@/features/admin/pages/Integrations/index';
import { TeamManagement } from '@/features/admin/pages/TeamManagement/index';
import { KnowledgeBase } from '@/features/admin/pages/KnowledgeBase/KnowledgeBase';
import { SessionAnalytics } from '@/features/admin/pages/SessionAnalytics/index';
import { RecentCalls } from '@/features/admin/pages/RecentCalls/index';
import { Profile } from '@/features/admin/pages/Profile/index';
import { PreCallIntel } from '@/features/admin/pages/PreCallIntel/PreCallIntel';
import { PreCallCallback } from '@/features/admin/pages/PreCallCallback';
import { Billing } from '@/features/admin/pages/Billing/Billing';

export const AppRoutes = () => {
  return (
    <Routes>
      {/* Public Routes */}
      <Route path="/" element={<Navigate to="/login" replace />} />
      <Route path="/login" element={<Login />} />
      <Route path="/signup" element={<Signup />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      
      {/* Protected Admin Routes */}
      <Route 
        path="/admin" 
        element={
          <ProtectedRoute allowedRoles={['Admin', 'SuperAdmin', 'member']}>
            <AdminLayout />
          </ProtectedRoute>
        }
      >
        <Route path="dashboard" element={<Dashboard />} />
        <Route path="organizations" element={<ProtectedRoute allowedRoles={['SuperAdmin']}><SuperOrganizations /></ProtectedRoute>} />
        <Route path="organizations/:orgId/members" element={<ProtectedRoute allowedRoles={['SuperAdmin']}><SuperOrgMembers /></ProtectedRoute>} />
        <Route path="copilot-settings" element={<ProtectedRoute allowedRoles={['Admin', 'SuperAdmin', 'member']}><SharkSettings /></ProtectedRoute>} />
        <Route path="integrations" element={<ProtectedRoute allowedRoles={['Admin', 'SuperAdmin', 'member']}><Integrations /></ProtectedRoute>} />
        <Route path="team" element={<ProtectedRoute allowedRoles={['Admin']}><TeamManagement /></ProtectedRoute>} />
        <Route path="knowledge" element={<ProtectedRoute allowedRoles={['SuperAdmin', 'Admin']}><KnowledgeBase /></ProtectedRoute>} />
        <Route path="calls" element={<RecentCalls />} />
        <Route path="sessions/:id" element={<SessionAnalytics />} />
        <Route path="profile" element={<Profile />} />
        <Route path="pre-call" element={<PreCallIntel />} />
        <Route path="pre-call/callback" element={<PreCallCallback />} />
        <Route path="billing" element={<ProtectedRoute allowedRoles={['Admin', 'SuperAdmin', 'member']}><Billing /></ProtectedRoute>} />
      </Route>
    </Routes>
  );
};
